// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  TradeSlotRow,
} from "./types";

export default {
  action: __t.u32(),
  name: __t.string(),
  get slots() {
    return __t.array(TradeSlotRow);
  },
  copper: __t.i64(),
  revision: __t.u32(),
};
